import request from '@/utils/request'

// 获取表单项
export const getFormItem = (formId) => request({
  url: '/bd/form/getFormInfo',
  method: 'get',
  params: { formId }
})
// 获取省市区树
export const getRegionTree = () => request({
  url: '/bd/region/list',
  method: 'get'
})
// 发起服务
export const appleService = (data) => request({
  url: '/workOnLine/employ/apply/create',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 上传文件
export function uploadApi(data) {
  return request({
    url: "/base/uploadWithName",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}